module.exports = __webpack_public_path__ + "img/banner1.70adc9cf.png";